import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import Cover from "./internal/styled";

export default class Overlay extends PureComponent {
  static propTypes = {
    /** Whether mouse events can pierce the overlay. If true, onOverlayClicked will not be fired. */
    canClickThrough: PropTypes.bool,
    /** Whether the overlay has a tinted background color. */
    isTinted: PropTypes.bool,
    /** Function called when the overlay is clicked. */
    onOverlayClicked: PropTypes.func
  };

  static defaultProps = {
    canClickThrough: false,
    isTinted: false,
    onOverlayClicked: () => {}
  };

  render() {
    const { canClickThrough, isTinted, onOverlayClicked } = this.props;
    const onClick = canClickThrough ? null : onOverlayClicked;
    const containerProps = { canClickThrough, isTinted, onClick };

    return <Cover {...containerProps} />;
  }
}
